/* eslint-disable */
export default {
  cancel: 'Abbrechen',
  close: 'Schließen',
  ok: 'OK',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
